<script setup>
	import { ref, onMounted, computed } from 'vue';
	import { useRouter, useRoute } from 'vue-router';
	import logo from '@/assets/logo.svg';
	import homeIcon from '@/assets/menu/home-icon.svg';
	import {
		useSetMap,
		useMapStoreData,
		useCategoriesStore,
		useMarkersStore,
		useFavoritesStore,
		useSearchData,
		useScenariosStore,
	} from '@/stores/index';
	import LanguageChanger from '@/components/LanguageChanger.vue';
	import Search from '@/components/Search.vue';
	import SortingDropdown from '@/components/SortingDropdown.vue';

	const selectedLanguage = ref('hr');
	//const showDropdownOrder = ref(false);
	const mapStore = useMapStoreData();
	const mapBoxStore = useSetMap();
	const headerSetup = ref(null);
	const hideLanguageSelector = ref(false);
	//const selectedOrder = ref('Alphabetical');
	const props = defineProps({
		setupHeader: Object,
	});
	let setData = useCategoriesStore();
	const router = useRouter();
	const route = useRoute();
	const pathRoute = computed(() => route.path == '/scenarios/');
	const searchRerender = ref(0);

	const emits = defineEmits(['changeOrderFilter', 'closeMap']);

	onMounted(() => {
		headerSetup.value = props.setupHeader.setupDataHeader;
		selectedLanguage.value = mapStore.currentLanguage;
		hideLanguageSelector.value = props.setupHeader.hideLanguage;
	});

	/*When filters in scenarios*/
	/*function changeOrder(order) {
    emits('changeOrderFilter', { order });
    selectedOrder.value = order;
    showDropdownOrder.value = false;
}*/
	function hideMap() {
		mapBoxStore.centerMapbox();
		emits('closeMap');

		useFavoritesStore().closeFavoritesPanel();
		if (mapStore.showMap) {
			mapStore.showMap = false;
			searchRerender.value++;
		}

		if (mapStore.showAiWizard) {
			mapStore.showAiWizard = false;
		}

		useSearchData().searchFilteredItems = [];
		setData.initializeFilters();
		router.push('/');
		useMapStoreData().activePoi = null;
		setTimeout(() => {
			if (useScenariosStore().activatedSorting != useScenariosStore().defaultSorting.key) {
				useScenariosStore().populateSortedMarkers(useScenariosStore().defaultSorting.key);
			}
		}, 300);
	}

	function openAiWizard() {
		mapStore.showAiWizard = true;
	}
</script>

<template>
	<div :class="[{ shortheader: props.setupHeader?.shortHeader }]" class="main-header">
		<div class="container">
			<div class="logo" @click="mapStore.showMap && !mapStore.isMapCopyMode && openAiWizard()">
				<img :src="logo" alt="" />
				<svg width="30" height="26" viewBox="0 0 30 26" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M15.4433 19.9497C15.6944 20.5342 16.0113 21.0977 16.394 21.6294L1.66962 21.6294C-0.55654 18.5364 -0.55654 14.364 1.66962 11.2711C3.51311 8.70975 3.83 5.40823 2.62028 2.59244C2.36917 2.00795 2.05229 1.44437 1.66962 0.912704L16.394 0.912704C18.6201 4.00569 18.6201 8.17807 16.394 11.2711C14.5505 13.8324 14.2336 17.1339 15.4433 19.9497ZM13.6433 19.9497C12.5201 16.754 12.9833 13.1368 15.0331 10.2889C16.6746 8.00832 16.8225 5.00356 15.4769 2.59244L4.42023 2.59244C5.5435 5.78807 5.08024 9.40526 3.03047 12.2532C1.38901 14.5338 1.2411 17.5386 2.58673 19.9497L13.6433 19.9497ZM30 25.6953L1.67836 25.6953L1.67836 23.8362L30 23.8362L30 25.6953Z"
						fill="#2E3D45"
					/>
				</svg>
			</div>
			<div v-show="props.setupHeader.search" class="search-container" data-cy="search-container">
				<Search v-if="useMarkersStore().mapSeen" v-show="(pathRoute || mapStore.showMap) && !mapStore.isMapCopyMode" :key="searchRerender"></Search>
				<SortingDropdown
					v-if="useMarkersStore().mapSeen"
					v-show="pathRoute && useMapStoreData().activePoi == null"
				></SortingDropdown>
			</div>
			<div class="menu">
				<div class="language-container">
					<LanguageChanger v-if="!hideLanguageSelector" uniqueClass="header-lang"></LanguageChanger>
				</div>
				<div class="home-menu-container">
					<div class="container" @click="hideMap()">
						<img data-cy="home-icon" class="home-icon" :src="homeIcon" alt="" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped lang="scss">
	@import '../assets/style/mixins.scss';
	@import '../assets/style/components/_header.scss';
</style>
